import React from 'react';
import errorIcon from '../../assets/error_warn.svg';

/* eslint-disable-next-line */
export interface InputBasicProps {
    label: string;
    name: string;
    value: string;
    onChange: (value: React.ChangeEvent<HTMLInputElement>) => void;
    onBlur: (value: React.ChangeEvent<HTMLInputElement>) => void;
    error?: boolean;
    errorMessage?: string;
    className?: string;
}

export function InputBasic(props: InputBasicProps) {
    return (
        <div className={`${props.className ? props.className : 'mb-4 relative'}`}>
            <label className="mb-2 block text-sm" htmlFor={props.name}>
                {props.label}
            </label>
            <input
                name={props.name}
                className={`input-base bg-white ${
                    props.error && 'border-red-500 focus:border-red-500 hover:border-red-700'
                }`}
                value={props.value}
                onChange={props.onChange}
                onBlur={props.onBlur}
            />
            {props.error && (
                <img
                    className={`absolute right-3 ${props.error ? 'bottom-9' : ' bottom-2 3xl:bottom-3'}`}
                    src={errorIcon}
                    alt="icon-error"
                />
            )}
            {props.error && <p className="text-red-500 text-xs mt-2">{props.errorMessage}</p>}
        </div>
    );
}

export default InputBasic;
